import * as React from 'react';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { MobileDatePicker } from '@mui/x-date-pickers';
import dayjs, { Dayjs } from 'dayjs';
import 'dayjs/locale/pt-br';

interface IDatePickerProps {
    selectedDate: Dayjs | null;
    onDateChange: (newDate: Dayjs | null) => void;
}

export const DatePicker: React.FC<IDatePickerProps> = ({ selectedDate, onDateChange }) => {
    const handleDateChange = (newDate: Dayjs | null) => {
        onDateChange(dayjs(newDate).startOf('month'));
    };

    return (
        <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="pt-br">
            <MobileDatePicker
                label="Selecione a data"
                openTo="month"
                views={['year', 'month']}
                value={selectedDate}
                onChange={handleDateChange}
                autoFocus={false}
                sx={{ width: '100%' }}
                closeOnSelect={true}
            />
        </LocalizationProvider>
    );
};
